import { faMultiply, faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useRef } from "react";
import { Button } from "react-bootstrap";
import styles from '../styles/fileupload.module.css';
import { useFieldArray } from "react-hook-form";
import ButtonOverride from "./buttonoverride";
import useApi from "../hooks/use-api";
import useMessageStore from "../stores/message-store";

const smallAddButtonStyle = {
    borderRadius: "50%",
    width: "32px",
    height: "32px",
    minWidth: "32px",
    minHeight: "32px",
    padding: 0,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
};

const largeAddButtonStyle = {
    borderRadius: "50%",
    width: "42px",
    height: "42px",
    minWidth: "42px",
    minHeight: "42px",
    padding: 0,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
};

const FileUpload = ({title = "File Upload",multiple = false,previousFiles = [],newFiles = [],setNewFiles,setPrevFiles,prevFileDownloadEndpointKey,FileDownloadData,readOnly = false,...props}) => {
    const fileRef = useRef(null);

    const _handleFileAddClick = () => {
        if(fileRef?.current){
            fileRef.current.click();
        }
    }
    const _handleFileAddChange = (e) => {
        const selectedFiles = Array.from(e.target.files).map(file => ({
            file
          }));

          const updatedFiles = [...newFiles];
          
          selectedFiles.forEach(newFile => {
            const existingFileIndex = updatedFiles.findIndex(existingFile => existingFile.file.name === newFile.file.name);
            if (existingFileIndex !== -1) {
                updatedFiles.splice(existingFileIndex, 1);
            }
            updatedFiles.push(newFile);
        });
        
        setNewFiles(updatedFiles);


        fileRef.current.value = "";
    }

    const _handleFileRemove = (file) => {
        setNewFiles(prev => 
            prev.filter(fileObj => 
                fileObj.file.name !== file.name
            )
        )
    }

    const _handlePrevRemove = (id) => {
        setPrevFiles(prev => 
            prev.filter(item => item.id !== id)
        )
    }

    const {getFileRequest} = useApi();
    const addToast = useMessageStore(state => state.addToast);

    const _handleFileDownload = (fileId,fileName) => {
        const download = async() => {
            const response = await getFileRequest(prevFileDownloadEndpointKey,{FileID : fileId,...FileDownloadData});

            if(response.status === 200){
                const url = window.URL.createObjectURL(new Blob([response.data]));

                const link = document.createElement('a');

                link.href = url;

                link.setAttribute('download',fileName);

                document.body.appendChild(link);

                link.click();

                link.parentNode.removeChild(link);
            }
            else{
                addToast(
                    {
                        id: Math.random(),
                        body: "An error occured when downloading the requested file.",
                        autoHide: true,
                        errorFlag: true,
                        timestamp: Date.now() - 1000
                    }
                )
            }
        }

        download();
    }

    return(
        <>
            <div {...props}>
                <div className="d-flex justify-content-center align-items-center">
                    <h6 className="mb-0 fw-bold">{title}</h6>
                    {
                        !readOnly && newFiles.length + previousFiles.length > 0 &&
                        <Button type="button" variant="success" aria-label="Add Document(s)" title="Add Document(s)" onClick={_handleFileAddClick} className={`ms-1 ${styles.addFileButtonZ} ${styles.smallz}`} style={smallAddButtonStyle}>
                            <FontAwesomeIcon icon={faPlus} />
                        </Button>
                    }
                </div>
                <div className={styles.mainContainer}>
                    {
                        !readOnly && newFiles.length + previousFiles.length === 0 &&
                            <Button type="button" variant="success" aria-label="Add Document(s)" title="Add Document(s)" onClick={_handleFileAddClick} className={`${styles.addFileButtonZ} ${styles.largez}`} style={largeAddButtonStyle}>
                                <FontAwesomeIcon icon={faPlus} size="2xl"/>
                            </Button>
                    }
                    {
                        readOnly && newFiles.length + previousFiles.length === 0 &&
                            <div className="text-muted">
                                No documents to display.
                            </div>
                    }
                    {
                        newFiles.length > 0 &&
                            <div className={styles.addedDocumentsColumn}>
                                {
                                    newFiles.map((file,index) => (
                                        <div key={index} className={styles.addedDocumentsRow}>
                                            <a href={URL.createObjectURL(file.file)} target="_blank" rel="noopener noreferrer" className={styles.addedDoc} >
                                                {file.file.name}
                                            </a>
                                            {
                                                !readOnly
                                                ?
                                                    <ButtonOverride type="button" className={styles.deleteAddedButton} aria-label="Remove Document" title="Remove Document" onClick={() => _handleFileRemove(file.file)}>
                                                        <FontAwesomeIcon icon={faMultiply} size="lg" style={{color: 'red'}}/>
                                                    </ButtonOverride>
                                                :
                                                    null
                                            }
                                        </div>
                                    ))
                                }
                            </div>
                    }
                    {
                        previousFiles.length > 0 &&
                        <div className={styles.addedDocumentsColumn}>
                            {
                                previousFiles.map((file) => (
                                    <div key={file.id} className={styles.addedDocumentsRow}>
                                        <Button type="button" title="Download File" aria-label="Download File" variant="link" className={styles.addedDoc} onClick={() => _handleFileDownload(file.id,file.name)}>
                                            {file.name}
                                        </Button>
                                        {
                                            !readOnly
                                            ?
                                                <ButtonOverride type="button" className={styles.deleteAddedButton} aria-label="Remove Document" title="Remove Document" onClick={() => _handlePrevRemove(file.id)}>
                                                    <FontAwesomeIcon icon={faMultiply} size="lg" style={{color: 'red'}}/>
                                                </ButtonOverride>
                                            :
                                                null
                                        }
                                    </div>
                                ))
                            }
                        </div>
                    }
                </div>
            </div>
            {
                !readOnly
                ?
                    <input ref={fileRef} type="file" style={{display: 'none'}} multiple={multiple} onChange={_handleFileAddChange}/>
                :
                    null
            }
        </>
    )
}

export default FileUpload;
